import { listado } from "./listado";
import { api } from "./backend";

export function crear() {
  return {
    id: 0,
    nombre: "",
  };
}

export function listar(params) {
  return listado("paises/listar", params);
}

export function paraCombo() {
  return api.get("paises/paraCombo").then((r) => r.data);
}

export function cargar(id) {
  return api.get("paises/cargar&id=" + id).then((r) => r.data);
}

export function obtenerDivisa(id) {
  return api.get("paises/obtenerDivisa&id=" + id).then((r) => r.data);
}

export function insertar(pais) {
  return api.post("paises/insertar", { pais }).then((r) => r.data);
}

export function actualizar(pais) {
  return api.post("paises/actualizar", { pais }).then((r) => r.data);
}

export function eliminar(id) {
  return api.post("paises/eliminar", { id });
}
